const STORAGE_KEY = "itshophw-order-message-last-seen";

export interface MessageStorage {
  getLastSeenTimestamp(orderId: string): string | null;
  setLastSeenTimestamp(orderId: string, timestamp: string): void;
}

export class LocalStorageMessageStorage implements MessageStorage {
  getLastSeenTimestamp(orderId: string): string | null {
    const data = this.readAll();
    return data[orderId] ?? null;
  }

  setLastSeenTimestamp(orderId: string, timestamp: string): void {
    const data = this.readAll();
    data[orderId] = timestamp;
    this.safeWrite(data);
  }

  private readAll(): Record<string, string> {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}");
    } catch (error) {
      console.log("Failed to read message storage:", error);
      return {};
    }
  }

  private safeWrite(data: Record<string, string>): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.log("Failed to write message storage:", error);
    }
  }
}

export const messageStorage: MessageStorage = new LocalStorageMessageStorage();
